module.exports = __webpack_public_path__ + "img/manage04.9ead10c0.png";